import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { TooltipWrapper } from 'components/TooltipWrapper/TooltipWrapper';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { isCarouselCreative } from '../../../creative-creator/components/CarouselCardList/utils/isCarouselCreative';
import { useGridContext } from '../GridContextProvider/GridContextProvider';
import ToggleSwitchCellRenderer from './ToggleSwitchCellRenderer';

const TooltipMessage = ({ value, reportId, defaultMessage = 'Campaign Status' } = {}) => (
    <FormattedMessage id={`app.campaigns.${reportId}.state.tooltip.${value}`} defaultMessage={defaultMessage} />
);

const tooltipOptions = { interactive: false, arrow: true, placement: TOOLTIP_POSITION.RIGHT };

const StateCellRenderer = ({ data, isDisabled, ...rest }) => {
    const { isGridEditDisabled } = useGridContext();
    const { context, value, reportId, defaultMessage } = rest;
    const tooltipContent = useMemo(
        () =>
            isCarouselCreative(data) ? (
                <FormattedMessage
                    id="app.campaigns.creative.state.hierarchy.tooltip"
                    defaultMessage="To change a carousel card status please go to Edit Carousel"
                />
            ) : (
                <TooltipMessage value={value} reportId={reportId} defaultMessage={defaultMessage} />
            ),
        [data, value, reportId, defaultMessage]
    );

    return (
        <TooltipWrapper tooltipContent={tooltipContent} tooltipOptions={tooltipOptions}>
            <ToggleSwitchCellRenderer
                {...rest}
                data={data}
                disabled={isGridEditDisabled || isDisabled(data, context)}
            />
        </TooltipWrapper>
    );
};

StateCellRenderer.propTypes = {
    ...ToggleSwitchCellRenderer.propTypes,
    isDisabled: PropTypes.func,
};

StateCellRenderer.defaultProps = {
    isDisabled: () => false,
};

export default StateCellRenderer;
